import React from 'react';
import { Chip } from '@mui/material';

const AllFacilitiesAccessBadge = ({ role }) => {
  if (!role?.has_all_facilities_access) return null;

  return (
    <Chip
      size='small'
      label='All Facilities Access'
      color='primary'
      variant='outlined'
    />
  );
};

export default AllFacilitiesAccessBadge;
